import { GETAJINDA, INSERTAGENDA, UPDATEAJINDA, DELETEAJINDA } from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";

export const CreateAjendaAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/LawyerBook`, data);
    dispatch({
      type: INSERTAGENDA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: INSERTAGENDA,
      payload: "Error" + e,
    });
  }
};
export const GetAllAjendaAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/LawyerBook?${quary}`);
    dispatch({
      type: GETAJINDA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GETAJINDA,
      payload: "Error" + e,
    });
  }
};
export const UpdateAjendaAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/LawyerBook`, body);
    dispatch({
      type: UPDATEAJINDA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATEAJINDA,
      payload: "Error" + e,
    });
  }
};

export const DeleteAjendaAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/LawyerBook?id=${id}`);
    dispatch({
      type: DELETEAJINDA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETEAJINDA,
      payload: "Error" + e,
    });
  }
};
